import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function WhatThisIsNot() {
  return <section className="w-full bg-white py-24 px-6" data-id="element-514">
      <div className="max-w-4xl mx-auto" data-id="element-515">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="font-serif text-teal text-3xl md:text-4xl lg:text-5xl text-center mb-6" data-id="element-516">
          Lo que este trabajo no es
        </motion.h2>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-center font-serif italic text-gray-600 text-lg mb-16 max-w-2xl mx-auto" data-id="element-517">
          Esto no es para todos — y lo digo con respeto.
        </motion.p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-518">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-cream rounded-2xl p-8 border border-gray-200" data-id="element-519">
            <h3 className="font-serif text-teal-dark uppercase tracking-widest text-sm mb-6" data-id="element-520">
              No es para vos si
            </h3>
            <ul className="space-y-5" data-id="element-521">
              <li className="flex items-start gap-3" data-id="element-522">
                <X className="text-gray-400 mt-1 flex-shrink-0" size={18} strokeWidth={2} data-id="element-523" />
                <span className="text-gray-700 font-light leading-relaxed" data-id="element-524">
                  Buscás resultados instantáneos sin ninguna disposición de tu
                  parte.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-525">
                <X className="text-gray-400 mt-1 flex-shrink-0" size={18} strokeWidth={2} data-id="element-526" />
                <span className="text-gray-700 font-light leading-relaxed" data-id="element-527">
                  Esperás que alguien te resuelva la vida desde afuera.
                </span>
              </li>
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="bg-teal rounded-2xl p-8 text-white" data-id="element-528">
            <h3 className="font-serif text-gold uppercase tracking-widest text-sm mb-6" data-id="element-529">
              Lo que sí ocurre acá
            </h3>
            <ul className="space-y-5" data-id="element-530">
              <li className="flex items-start gap-3" data-id="element-531">
                <Check className="text-gold mt-1 flex-shrink-0" size={18} strokeWidth={2} data-id="element-532" />
                <span className="font-light leading-relaxed" data-id="element-533">
                  Tu campo se investiga.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-534">
                <Check className="text-gold mt-1 flex-shrink-0" size={18} strokeWidth={2} data-id="element-535" />
                <span className="font-light leading-relaxed" data-id="element-536">
                  Se depura y se restaura en lo que necesita ser restaurado.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-537">
                <Check className="text-gold mt-1 flex-shrink-0" size={18} strokeWidth={2} data-id="element-538" />
                <span className="font-light leading-relaxed" data-id="element-539">
                  Se crean las condiciones para que puedas moverte desde un
                  lugar diferente.
                </span>
              </li>
            </ul>
          </motion.div>
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="text-center font-serif italic text-teal-dark text-xl md:text-2xl mt-16 leading-relaxed" data-id="element-540">
          El trabajo energético es mío.
          <br data-id="element-541" />
          El camino sigue siendo tuyo.
        </motion.p>
      </div>
    </section>;
}